import { Component } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-payment-terms-and-conditions',
  templateUrl: './payment-terms-and-conditions.component.html',
  styleUrls: ['./payment-terms-and-conditions.component.css']
})
export class PaymentTermsAndConditionsComponent {

  constructor(public shared: SharedService) {
    this.shared.isWhiteMenu = true;
  }

}
